/* eslint-disable react/prop-types */
import React, { Component } from "react"
import PropTypes from "prop-types"

const resizeComponent = TargetComponent =>
  class ResizeComponent extends Component {
    constructor() {
      super()
      this.state = { containerWidth: null, containerHeight: null }
      this.fitParentContainer = this.fitParentContainer.bind(this)
    }

    componentDidMount() {
      this.fitParentContainer()

      setTimeout(() => {
        this.fitParentContainer()
      }, 250)

      window.addEventListener("resize", this.fitParentContainer)
    }

    componentWillUnmount() {
      window.removeEventListener("resize", this.fitParentContainer)
    }

    fitParentContainer() {
      if (this.chartContainer !== null) {
        const { width, height } = this.chartContainer.getBoundingClientRect()

        this.setState({
          containerWidth: width,
          containerHeight: height
        })
      }
    }

    render() {
      const { containerWidth, containerHeight } = this.state
      const { containerClasses, containerId } = this.props
      const shouldRenderChart = containerWidth !== null

      return (
        <div
          ref={el => (this.chartContainer = el)}
          className={`w-100 h-100 ${containerClasses}`}
          id={containerId}
        >
          {shouldRenderChart && (
            <TargetComponent
              containerWidth={containerWidth}
              containerHeight={containerHeight}
              {...this.props}
            />
          )}
        </div>
      )
    }
  }

export default resizeComponent

resizeComponent.propTypes = {
  containerClasses: PropTypes.string,
  containerId: PropTypes.string
}

resizeComponent.defaultProps = {
  containerClasses: "",
  containerId: ""
}
